import { render, staticRenderFns } from "./AssessmentDetails.vue?vue&type=template&id=7c64b085&scoped=true"
import script from "./AssessmentDetails.vue?vue&type=script&lang=js"
export * from "./AssessmentDetails.vue?vue&type=script&lang=js"
import style0 from "./AssessmentDetails.vue?vue&type=style&index=0&id=7c64b085&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c64b085",
  null
  
)

export default component.exports